module.exports = __webpack_public_path__ + "img/bmbg.4d2af6b5.gif";